
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import Button from './Button';

const FloatingCTA: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight;
      const winHeight = window.innerHeight;
      const scrollPercent = scrollTop / (docHeight - winHeight);

      setIsVisible(scrollPercent > 0.5);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40 animate-fade-in-up">
      <Link to="/kontakt" onClick={handleClick}>
        <Button 
          variant="secondary" 
          className="shadow-elegant hover:shadow-elegant-lg"
          icon={<MessageCircle className="w-4 h-4" />}
        >
          Kontakt aufnehmen
        </Button>
      </Link>
    </div>
  );
};

export default FloatingCTA;
